<script setup>
import { Link } from '@inertiajs/vue3'
import UiStatusPill from '@/Components/UI/UiStatusPill.vue'
import UiButton from '@/Components/UI/UiButton.vue'
import { useI18n } from 'vue-i18n'

defineProps({
  subRental: { type: Object, required: true }
})
defineEmits(['record-payment'])

const { t } = useI18n()
</script>

<template>
  <tr class="border-b border-[color:var(--line)]">
    <td class="py-2">
      <Link :href="`/vehicles/${subRental.vehicle_id}`" class="text-[color:var(--accent)] hover:underline">
        {{ subRental.vehicle_label }}
      </Link>
    </td>
    <td class="py-2 text-sm text-[color:var(--inkSoft)]">
      {{ subRental.start_on }} – {{ subRental.end_on || '—' }}
    </td>
    <td class="py-2 text-right tabular-nums">{{ subRental.rate_display }}</td>
    <td class="py-2 text-right tabular-nums fw-value">{{ subRental.planned_to_date }}</td>
    <td class="py-2 text-right tabular-nums fw-value">{{ subRental.paid }}</td>
    <td class="py-2 text-right tabular-nums fw-value" :class="subRental.balance_cents > 0 ? 'text-[color:var(--warn)]' : ''">
      {{ subRental.balance }}
    </td>
    <td class="py-2">
      <UiStatusPill
        :tone="subRental.active ? 'ok' : 'muted'"
        :label="subRental.active ? t('sub_rentals.status.active') : t('sub_rentals.status.ended')"
      />
    </td>
    <td class="py-2 text-right">
      <UiButton variant="ghost" size="sm" @click="$emit('record-payment', subRental)">
        {{ t('supplier_payments.record') }}
      </UiButton>
    </td>
  </tr>
</template>
